<template>
  <div class="section-browser">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Playback Details</h1>
      </div>
      <div class="section-body">
        <div class="information-container" v-if="data && !isEmpty && !isError">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="side-card-container">
                <div class="card-side-graph">
                  <div class="card-icon error-section-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                  </div>
                  <div class="card-section-body" v-if="data">
                    <div class="header">Error</div>
                    <h3 class="error-section">{{data.mainInfo[1].value}}</h3>
                  </div>
                </div>
                <div class="card-side-graph">
                  <div class="card-icon buffer-section-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                  </div>
                  <div class="card-section-body" v-if="data">
                    <div class="header">Buffer</div>
                    <h3 class="buffer-section">{{data.mainInfo[0].value}}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-xl-12 section-left mt-4" v-if="data">
              <div class="list-header">User Info</div>
              <div class="item" v-for="(item,index) in data.userInfo" v-bind:key="index">
                <div v-if="item && item.type === 'list'">
                  <div class="header">{{item.key}}</div>
                  <ul>
                    <li
                      v-for="(childitem,childIndex) in item.value"
                      v-bind:key="childIndex"
                    >{{childitem.name}} ({{childitem.count}})</li>
                  </ul>
                </div>
                <div v-else>
                  <div class="header">{{item.key}}</div>
                  <div class="value">{{item.value}}</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-xl-12 section-left mt-4" v-if="data">
              <div class="list-header">Device Info</div>
              <div class="item" v-for="(item,index) in data.deviceInfo" v-bind:key="index">
                <div v-if="item && item.type === 'list'">
                  <div class="header">{{item.key}}</div>
                  <ul>
                    <li
                      v-for="(childitem,childIndex) in item.value"
                      v-bind:key="childIndex"
                    >{{childitem.name}} ({{childitem.count}})</li>
                  </ul>
                </div>
                <div v-else>
                  <div class="header">{{item.key}}</div>
                  <div class="value">{{item.value}}</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-xl-12 section-middle mt-4" v-if="data">
              <div class="list-header">Playback Info</div>
              <div class="item" v-for="(item,index) in data.playbackInfo" v-bind:key="index">
                <div v-if="item && item.type === 'list'">
                  <div class="header">{{item.key}}</div>
                  <ul>
                    <li
                      v-for="(childitem,childIndex) in item.value"
                      v-bind:key="childIndex"
                    >{{childitem.name}} ({{childitem.count}})</li>
                  </ul>
                </div>
                <div v-else>
                  <div class="header">{{item.key}}</div>
                  <div class="value">{{item.value}}</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-xl-12 section-right mt-4" v-if="data">
              <div class="list-header">Connection Info</div>
              <div class="item" v-for="(item,index) in data.connectionInfo" v-bind:key="index">
                <div v-if="item && item.type === 'list'">
                  <div class="header">{{item.key}}</div>
                  <ul>
                    <li
                      v-for="(childitem,childIndex) in item.value"
                      v-bind:key="childIndex"
                    >{{childitem.name}} ({{childitem.count}})</li>
                  </ul>
                </div>
                <div v-else>
                  <div class="header">{{item.key}}</div>
                  <div class="value">
                    <span
                      v-if="item && item.value && item.type === 'flag'"
                      :class="`flag-icon flag-icon-${item.value.toLowerCase()}`"
                    ></span>
                    {{item.value}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EmptyMessage v-if="!isLoading && isEmpty && !isError">
          ไม่พบข้อมูลในช่วงเวลาดังกล่าว
        </EmptyMessage>
        <EmptyMessage v-if="!isLoading && isError">
          <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
          <p>
            โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
            <a
              :href="`mailto:support@byteark.com`"
              target="_top"
            >support@byteark.com</a>
          </p>
          <span slot="code" class="code">error code : {{error.status || 'not found' }}</span>
        </EmptyMessage>
        <div v-if="isLoading" class="d-flex justify-content-center">
          <div class="spinner-border" role="status" />
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.css';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: ['data', 'isEmpty', 'isLoading', 'isError', 'error'],
  components: {
    Section,
    EmptyMessage,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.error-container {
  display: flex;
  flex-direction: row;
  text-align: center;
  padding: $spacer;
  justify-content: center;
  margin: $spacer;
  .item {
    margin: 0 $spacer * 2.5;
    .value {
      font-size: $font-size-base * 1.5;
      color: #3c3c3c;
    }
    .buffer {
      color: #ffc10c;
    }
    .error {
      color: #dd3645;
    }
  }
}

ul {
  padding-left: $spacer;
  margin-bottom: 0;
  li {
    font-size: $font-size-base * 0.875;
    color: #3c3c3c;
  }
}

.side-card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-bottom: 1px solid $gray-300;
  margin-bottom: $spacer;
}

.card-side-graph {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: $spacer;
  padding-bottom: $spacer * 2;

  &:first-child {
    border-right: 1px solid $gray-300;
  }

  .card-icon {
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    padding: $spacer * 0.5 $spacer;
  }

  .card-section-body {
    display: flex;
    flex-direction: column;
    margin-left: $spacer;
  }

  .buffer-section {
    color: #ffc10c;
    text-align: left;
  }

  .error-section {
    color: #dd3645;
    text-align: left;
  }

  .buffer-section-icon {
    background: #ffc10c;
  }

  .error-section-icon {
    background: #dd3645;
  }

  i {
    color: $white;
    font-size: $font-size-base * 1.5;
    line-height: 1.75em;
  }

  .header {
    color: $gray-600;
    font-size: $font-size-base;
    text-align: left;
    text-transform: uppercase;
  }

  h3 {
    color: $gray-800;
    font-size: $font-size-base * 1.5;
    margin: 0;
  }
}

.section-left,
.section-right,
.section-middle {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .list-header {
    width: 100%;
  }

  .item {
    flex: 0 0 25%;
    margin: $spacer / 2 0;

    .value {
      font-size: $font-size-base * 1.15;
      color: #3c3c3c;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

    .header {
      font-size: $font-size-base * 0.875;
      font-weight: 300;
      text-overflow: ellipsis;
      line-height: 1.5em;
      max-height: 1.5em;
      overflow: hidden;
    }
  }
}

@media (min-width: 768px) and (max-width: 1279.98px) {
  .section-left,
  .section-right,
  .section-middle {
    .item {
      flex: 0 0 50%;
      margin: $spacer / 2 0;
      .value {
        overflow-wrap: break-word;
        word-wrap: break-word;
        font-size: $font-size-base;
        color: #3c3c3c;
      }

      .header {
        font-size: $font-size-base * 0.75;
        font-weight: 300;
      }
      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media (max-width: 767.98px) {
  .section-left,
  .section-right,
  .section-middle {
    .item {
      flex: 0 0 50%;
      margin: $spacer / 3 0;
      .value {
        overflow-wrap: break-word;
        word-wrap: break-word;
        font-size: $font-size-base;
        color: #3c3c3c;
      }

      .header {
        font-size: $font-size-base * 0.75;
        font-weight: 300;
      }
      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .card-side-graph {
    .header {
      font-size: $font-size-base * 0.875;
      font-weight: 300;
      text-align: left;
    }

    .card-section-body {
      margin-left: $spacer / 4;
    }

    h3 {
      color: $gray-800;
      font-size: $font-size-base * 1.25;
      margin: 0;
    }

    i {
      color: $white;
      font-size: $font-size-base;
    }

    .card-icon {
      padding: $spacer / 2 $spacer / 1.75;
    }
  }

  .section-right {
    margin-top: $spacer;
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .item {
    margin: $spacer;
    .value {
      overflow-wrap: break-word;
      word-wrap: break-word;
      font-size: $font-size-base;
      color: #3c3c3c;
    }

    .header {
      font-size: $font-size-base * 0.875;
      font-weight: 300;
    }
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
